module.exports = __webpack_public_path__ + "img/explanation.3125df6b.png";